import React from 'react';
import { prop } from 'ramda';

import { Button } from '@core/js/components/common/Button';
import { Icon } from '@core/js/components/common/Icon';

import * as hooks from '@core/js/components/main/LogoutButton/hooks';
import * as Types from '@core/js/components/main/LogoutButton/types';
import { useTranslations } from '@core/js/hooks/i18n';
import { useUserSelector } from '@core/js/store/hooks';

import { AUTOMATED_TEST_IDS } from '@interlayer/js/custom/constants';
import { clsx } from '@interlayer/js/utils/classNames.util';

import style from './LogoutButton.scss';

export const LogoutButton: React.FC<Types.ILogoutButtonProps> = ({ className, classname, type = 'icon' }) => {
    const translate = useTranslations();
    const onClick = hooks.useOnLogoutButtonClick();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));

    if (!isLoggedIn) {
        return null;
    }

    return (
        <Button
            isNew
            type="button"
            onClick={onClick}
            id={AUTOMATED_TEST_IDS.headerLogoutBtn}
            className={clsx([className, classname, style.logoutBtn], 'cms-logout-button')}
        >
            {type === 'icon'
                ? (
                    <Icon
                        type="logout"
                        className={style.logoutIcon}
                        aria-label={translate('playtech.mobile.system.login.button.logout')}
                    />
                )
                : translate('playtech.mobile.system.login.button.logout')
            }
        </Button>
    );
};

export default LogoutButton;
